import React from "react";
import { Box, HStack, Image, Text, useBreakpointValue } from "@chakra-ui/react";
import { DataRecipient } from "../../Types/AppData";
import DataRightLogo from "../../Images/CDR-Accredited-Data-Right-Logo.webp";
import DataRightLogoNoText from "../../Images/CDR-Accredited-Data-Right-Logo-No-Text.webp";


export const ConsumerDataRightBox = ({
  dataRecipient,
}: {
  dataRecipient?: DataRecipient;
}) => {

  const logoSrc = useBreakpointValue({
    base: DataRightLogoNoText, 
    sm: DataRightLogo,         
  });
  
  return (
    <HStack
      mx={4}
      my={6}
      borderRadius="md"
      borderColor="gray.200"
      borderWidth={1}
      p={4}
    >
      <Box flex={1}>
        <Image
          p={3}
          w={"70%"}
          id="DataRightLogo"
          src={logoSrc}
          alt="Value proposition page data right logo"
        />
      </Box>
      <Box flex={1}>
        <Text>
          <b>{dataRecipient?.legalEntityName || "Legal Entity Name"}</b>
        </Text>
        <Text>
          Accredited Data Recipient:{" "}
          {dataRecipient?.accreditationNumber || "N/A"}
        </Text>
      </Box>
    </HStack>
  );
};
